
export class ActiveTabUtil{
    constructor(){
        
    }

    setActiveTabForPopUp(tab,tabDetails){
        tabDetails.map(t=>{
          jQuery('#'+t["id"]).removeClass('active')
        })
        setTimeout(() => {
          jQuery('#'+tab["id"]).addClass('active')
        }, 10);
          
        setTimeout(() => {
            var elWidth = (document.querySelector('.slidemenu-modal')) as any;
            var slider = (document.querySelector('.modal-slider')) as any;
            var label = (document.querySelectorAll(".pop-up-label")) as any;
            var labelWidth = elWidth.offsetWidth/(tabDetails.length) + "px";
            label.forEach(tab => {
              tab.style.width = labelWidth;
            });
            // var left = label.offsetLeft;
                
            slider.style.width = labelWidth;
            var left = $("#"+tab["id"]).position()?.left;
            slider.style.transform = "translateX("+left+"px)"
        }, 200);
      }
}